import {
  createAsyncAction,
  createStandardAction,
  createAction,
} from "typesafe-actions";
import { ILine, ILineUpdate, LineID } from "../api/APIClient";
import APIError from "src/api/APIError";

export const showEditLine = createStandardAction("SHOW_EDIT_LINE")<LineID>();
export const showCreateLine = createStandardAction("SHOW_CREATE_LINE")();
export const toggleLineModalOpen = createAction("TOGGLE_LINE_MODAL");

export const updateLineProgress = createAsyncAction(
  "UPDATE_LINE_REQUEST",
  "UPDATE_LINE_SUCCESS",
  "UPDATE_LINE_FAILURE"
)<ILineUpdate, ILine, APIError>();

export const createLineProgress = createAsyncAction(
  "CREATE_LINE_REQUEST",
  "CREATE_LINE_SUCCESS",
  "CREATE_LINE_FAILURE"
)<ILine, ILine, APIError>();

export const deleteLineProgress = createAsyncAction(
  "DELETE_LINE_REQUEST",
  "DELETE_LINE_SUCCESS",
  "DELETE_LINE_FAILURE"
)<LineID, ILine, APIError>();

export const fetchLinesProgress = createAsyncAction(
  "FETCH_LINES_REQUEST",
  "FETCH_LINES_SUCCESS",
  "FETCH_LINES_FAILURE"
)<void, ILine[], Error>();



// WEBPACK FOOTER //
// ./src/actions/lineActions.ts